export default __webpack_public_path__ + "static/media/RobotoMono-Bold.5c4753e4.woff";